import { isAppleDevice } from './layout.ts'
import { isCapacitorNative } from '../api/ZionServer.ts'

export type Screen =
  | 'auth'
  | 'home'
  | 'search'
  | 'chat'
  | 'pair'
  | 'linkDevice'
  | 'linkDeviceScan'
  | 'addToHome'
  | 'settings'
  | 'tempChatDuration'
  | 'tempChat'

type NavigateFn = (screen: Screen, params?: Record<string, string>) => void

let navigateFn: NavigateFn = () => {}
let screenParams: Record<string, string> = {}

export function setNavigator(fn: NavigateFn): void {
  navigateFn = fn
}

export function navigate(screen: Screen, params: Record<string, string> = {}): void {
  screenParams = params
  navigateFn(screen, params)
}

export function getParam(key: string): string {
  return screenParams[key] ?? ''
}

export function isStandalonePwa(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true
  )
}

/** Guida “Aggiungi a Home” — mai su Capacitor nativo (app già installata). */
export function shouldShowAddToHomeGuide(): boolean {
  if (isCapacitorNative()) return false
  return isAppleDevice() && !isStandalonePwa()
}
